module.exports = __webpack_public_path__ + "static/media/3_placeholder_it.a842ea04.png";